//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/TaggedObject.js";
import "../GeometricUtilities/GeometricUtilities.ParentEquivalencyMapList.js";
import "../GeometricUtilities/GeometricUtilities.EntityUsageInfoList.js";
import "../no/ObjectList.js";
let d=[[[0,"Allowance",1,0],[1,"MatchList",0,"GeometricUtilities.ParentEquivalencyMapList",0],[0,"MatchObjectsWithDependentsOnly",1,0],[0,"MatchSheetBoundariesOnly",1,0],[0,"OneToOne",1,0],[1,"UsageInfoList",0,"GeometricUtilities.EntityUsageInfoList",0]],[[[],"Enter",{},0,0],[[],"Exit",{},0,0],[[],"CreateEmptyMatch",{R_:{pem:"GeometricUtilities.ParentEquivalencyMap"}},0,0],[[],"QueryFeatureOutputUsage",{R_:{nImportantEntititesFound:''}},0,0],[["numMaps","maps"],"CreateNameBasedMaps",{},0,0],[["numMaps","maps"],"CreateInferredMaps",{},0,0],[["numMaps","maps"],"CreateGeometricMaps",{},0,0],[["replacementObjects"],"SetNewParents",{},1,0],[["prodInt"],"SetProdInt",{},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.GeometricUtilities.ReplAsstBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.ReplAsstBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;